// Copyright (c) Brock Allen & Dominick Baier. All rights reserved.
// Licensed under the Apache License, Version 2.0. See LICENSE in the project root for license information.

import { Log } from './Log.js';
import { UrlUtility } from './UrlUtility.js';
import { State } from './State.js';

export class SignoutRequest {
    constructor({url, post_logout_redirect_uri, client_id}) {
        if (!url) {
            Log.error("SignoutRequest.ctor: No url passed");
            throw new Error("url");
        }

        if (post_logout_redirect_uri) {
            url = UrlUtility.addQueryParam(url, "logout_uri", post_logout_redirect_uri);
        }

        if (client_id){
            url = UrlUtility.addQueryParam(url, "client_id", client_id);
        }

        this.url = url;
    }
}
